import ApiServer from "../../ApiServer.ts";
import * as Redim from "../../lib/redim/imageRedim.ts";
import * as Html from "../../util/Html.ts";
import * as Medias from "../../server/Medias.ts";

export {initDom}
Html.registerWidget('widget/form/input-coverauto',{initDom})

/**
 * must be set on a tag LABEL
 * input for cover, if a name is not set the cover is automaticaly updated
 * if set, it will be uploaded when the form is submitted (so set good name)
 */
function initDom(node: HTMLElement){

  let currentValue: string | undefined;
  let inputFile: HTMLInputElement;
  const name = node.getAttribute('data-name');

  if(name){
    node.insertAdjacentHTML('beforeend', `<input name="${name}" type="file" style="display:none" accept="image/*">`);
  }else{
    node.insertAdjacentHTML('beforeend', '<input type="file" style="display:none" accept="image/*">');
  }
  inputFile = node.querySelector('input') as HTMLInputElement;

  function onchange(blob: Blob){
    currentValue = URL.createObjectURL(blob);
    node.style.backgroundImage = `url('${currentValue}')`;
    if(!name){
      ApiServer.accupdatefamily(null,null,blob,function(){
        currentValue = undefined;
      })
    }
  }

  inputFile.addEventListener('change', async function(this: HTMLInputElement){
    if(!this.files || !this.files[0]){
      return;
    }
    if(!await Medias.checkQuota()) return;

    try {
      const blob = await Redim.downsize(this.files[0], {width:1024, height:1024});
      onchange(blob);
    } catch(e) {
      console.error('Downsize error:', e);
      onchange(this.files[0]);
    }
  });

  if(currentValue){
    node.style.backgroundImage = `url('${currentValue}')`;
  }

  node.addEventListener("click", function(e){
    const menuOpen = node.closest(".fw-menu-open");
    if(menuOpen){
      e.preventDefault();
      (menuOpen as HTMLElement).click();
    }
  });
}